<template>
  <div class="container">
    <!-- 侧边栏 -->
    <vs-sidebar
      absolute
      :reduce="sidebarReduced"
      v-model="active"
      open
    >
      <template #logo>
        <img :src="require('@/assets/TJ.jpg')" alt="Logo" style="height:250px;width: auto;">
      </template>

      <!-- 展开/收起按钮 -->
      <div class="sidebar-toggle-btn" @click="sidebarReduced = !sidebarReduced">
        <div class="gt-arrow" :class="{ expanded: !sidebarReduced }">
          <span class="line line-1"></span>
          <span class="line line-2"></span>
        </div>
      </div>

      <!-- 桥隧路网组 -->
      <vs-sidebar-group>
        <template #header>
          <vs-sidebar-item :arrow="!sidebarReduced">
            <template #icon>
              <i class="bx bxs-map-pin"></i>
            </template>
            <span @click.stop="handleMenuClick('/roadnet')">城市大规模桥隧群</span>
          </vs-sidebar-item>
        </template>
        <vs-sidebar-item id="sh-bridges" @click="handleMenuClick('/sandbox')">
          <template #icon>
            <i class='bx bxs-network-chart'></i>
          </template>
          上海桥隧群
        </vs-sidebar-item>
        <vs-sidebar-item id="wh-bridges" @click="handleMenuClick('/SandboxWuhan')">
          <template #icon>
            <i class='bx bxs-network-chart'></i>
          </template>
          武汉桥隧群
        </vs-sidebar-item>
      </vs-sidebar-group>

      <vs-sidebar-item id="traffic" @click="handleMenuClick('/trafficflow')">
        <template #icon>
          <i class='bx bxs-traffic'></i>
        </template>
        交通流量
      </vs-sidebar-item>

      <!-- 重点桥隧组 -->
      <vs-sidebar-group>
        <template #header>
          <vs-sidebar-item :arrow="!sidebarReduced">
            <template #icon>
              <i class="bx bxs-message-alt-error bx-flip-horizontal"></i>
            </template>
            重点桥隧
          </vs-sidebar-item>
        </template>

        <vs-sidebar-item id="上海桥梁" @click.native="handleMenuClick('/ModelMain')">
          <template #icon>
            <i class="bx bxs-network-chart"></i>
          </template>
          上海桥梁
        </vs-sidebar-item>
        <vs-sidebar-item id="武汉桥梁" @click.native="handleMenuClick('/ModelMainwh')">
          <template #icon>
            <i class="bx bxs-network-chart"></i>
          </template>
          武汉桥梁
        </vs-sidebar-item>
      </vs-sidebar-group>



      <!-- 侧边栏底部 -->
      <template #footer>
        <vs-row justify="space-between">
          <vs-avatar badge-color="danger" badge-position="top-right">
            <i class="bx bx-bell"></i>
            <template #badge>28</template>
          </vs-avatar>
          <vs-avatar>
            <img :src="require('@/assets/R.png')" alt="Logo" style="height:100px;width: auto;">
          </vs-avatar>
        </vs-row>
      </template>
    </vs-sidebar>

    <!-- 地图部分 -->
    <div class="content">
      <h1>交通流监控</h1>
      <baidu-map class="map" :center="center" :zoom="zoom" :scroll-wheel-zoom="true">
        <bm-navigation></bm-navigation>
        <bm-scale></bm-scale>
        <bm-traffic></bm-traffic>

        <bm-marker :position="yangpuBridge" @click="goToModelPage" :icon="redIcon" @mouseover="showInfoWindow" @mouseout="hideInfoWindow">
          <bm-label content="点击以查看杨浦大桥" :offset="labelOffset"></bm-label>
        </bm-marker>

        <bm-info-window v-if="infoVisible" :position="yangpuBridge" title="杨浦大桥">
          <div>维修（道路半封闭）</div>
        </bm-info-window>

        <bm-marker :position="beihongBridge" @click="goToModelPage" :icon="greenIcon">
          <bm-label content="点击以查看北虹高架" :offset="labelOffset"></bm-label>
        </bm-marker>

        <bm-marker :position="dalianTunnel" @click="goToModelPage" :icon="greenIcon">
          <bm-label content="点击以查看大连路隧道" :offset="labelOffset"></bm-label>
        </bm-marker>

        <bm-marker :position="xinjianTunnel" @click="goToModelPage" :icon="greenIcon">
          <bm-label content="点击以查看新建路隧道" :offset="labelOffset"></bm-label>
        </bm-marker>
      </baidu-map>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrafficFlowMonitor',
  data() {
    return {
      active: 'traffic',
      sidebarReduced: false,
      infoVisible: false,
      center: { lng: 121.5522, lat: 31.2612 },
      zoom: 15,
      yangpuBridge: { lng: 121.5522, lat: 31.2612 },
      beihongBridge: { lng: 121.43109367982458, lat: 31.126501385745613 },
      dalianTunnel: { lng: 121.5206, lat: 31.2643 },
      xinjianTunnel: { lng: 121.5115, lat: 31.2425 },
      labelOffset: { width: 20, height: -10 },
      greenIcon: {
        url: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png',
        size: { width: 32, height: 32 }
      },
      redIcon: {
        url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
        size: { width: 32, height: 32 }
      }
    };
  },
  mounted() {
    this.active = 'traffic';
  },
  methods: {
    handleMenuClick(route) {
      // 折叠状态亦可点击跳转
      this.$router.push(route);
    },
    navigateTo(path) {
      this.handleMenuClick(path);
    },
    openNotification1(position = null, color, icon) {
      this.$vs.notification({
        icon,
        color,
        position,
        title: '突发状况',
        text: `大连路隧道发生交通事故造成严重拥堵`
      })
    },
    openNotification2(position = null, color, icon) {
      this.$vs.notification({
        icon,
        color,
        position,
        title: '危险警告',
        text: `杨浦大桥车辆负载可能增大`
      })
    },
    goToModelPage() {
      this.$router.push('/model');
    },
    showInfoWindow() {
      this.infoVisible = true;
    },
    hideInfoWindow() {
      this.infoVisible = false;
    }
  }
};
</script>

<style scoped>
/* 展开/收起按钮 */
.sidebar-toggle-btn {
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: background 0.2s;
}
.sidebar-toggle-btn:hover {
  background: #f0f5ff;
}

/* 大于号线条 */
.gt-arrow {
  width: 14px;
  height: 14px;
  position: relative;
  transition: transform 0.2s;
}
.gt-arrow.expanded {
  transform: rotate(180deg);
}
.line {
  position: absolute;
  width: 12px;
  height: 2.5px;
  background: #555;
  border-radius: 1px;
  top: 50%;
  left: 0;
  transform-origin: right center;
}
.line-1 {
  transform: rotate(-35deg) translateY(-50%);
}
.line-2 {
  transform: rotate(35deg) translateY(-50%);
}

/* 布局样式 */
.container {
  display: flex;
  height: 100vh;
}
.vs-sidebar {
  width: 250px;
}
.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa, #c3cfe2);
  font-family: 'Arial', sans-serif;
  color: #333;
}
.map {
  height: 80vh;
  width: 90vw;
  margin-top: 20px;
  border: 2px solid #ccc;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
h1 {
  margin-top: 20px;
  font-size: 2.5em;
  color: #4f83cc;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
}
</style>